var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRealEstate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.5,
    height: 23.5,
    viewBox: "0 0 23.5 23.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2421",
    "data-name": "Caminho 2421",
    d: "M24.071,2.25H14a1.68,1.68,0,0,0-1.679,1.679v8.393H3.929A1.68,1.68,0,0,0,2.25,14V25.75h23.5V3.929A1.68,1.68,0,0,0,24.071,2.25ZM8.125,24.071V18.2h3.357v5.875Zm15.946,0H13.161V17.357a.839.839,0,0,0-.839-.839H7.286a.839.839,0,0,0-.839.839v6.714H3.929V14H14V3.929H24.071Z",
    transform: "translate(-2.25 -2.25)",
    fill: "#7e84a3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2422",
    "data-name": "Caminho 2422",
    d: "M20.25,9h1.679v1.679H20.25Z",
    transform: "translate(-6.821 -3.964)",
    fill: "#7e84a3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2423",
    "data-name": "Caminho 2423",
    d: "M27,9h1.679v1.679H27Z",
    transform: "translate(-8.536 -3.964)",
    fill: "#7e84a3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2425",
    "data-name": "Caminho 2425",
    d: "M27,15.75h1.679v1.679H27Z",
    transform: "translate(-8.536 -5.679)",
    fill: "#7e84a3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2426",
    "data-name": "Caminho 2426",
    d: "M20.25,22.5h1.679v1.679H20.25Z",
    transform: "translate(-6.821 -7.393)",
    fill: "#7e84a3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealEstate);
export default __webpack_public_path__ + "static/media/real-estate.6cf125b167f17d5f277a702059ad7d68.svg";
export { ForwardRef as ReactComponent };